var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Cookies from 'js-cookie';
import { platform_base_url } from './config';
import { getCookieDomain } from './util';
import { get } from './request'; // eslint-disable-line import/no-cycle
import { trackEvent as dataLayerPush } from './track';
export var BOMBAS_GUID_COOKIE = 'bombas-guid';
export var BROWSER_GUID_COOKIE = 'BOM-BROWSER_GUID';
var TEN_YEARS = 365 * 10;
/**
 * Returns a user GUID by returning an existing value or fetching a new one from the customer service
 */
export var getUserId = function () { return __awaiter(void 0, void 0, void 0, function () {
    var id, json, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                id = Cookies.get(BOMBAS_GUID_COOKIE);
                if (id)
                    return [2 /*return*/, Promise.resolve(id)];
                if (window.isRequestingUserId) {
                    // lock to prevent simultaneous api calls
                    return [2 /*return*/, new Promise(function (resolve, reject) {
                            var lock = setInterval(function () {
                                if (!window.isRequestingUserId) {
                                    clearInterval(lock);
                                    var value = Cookies.get(BOMBAS_GUID_COOKIE);
                                    if (value) {
                                        resolve(value);
                                    }
                                    else {
                                        reject(new Error('Unable to retrieve bombas-guid cookie.'));
                                    }
                                }
                            }, 50);
                        })];
                }
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                window.isRequestingUserId = true;
                return [4 /*yield*/, get("".concat(platform_base_url, "/v1/customers/customer"), {
                        credentials: 'include'
                    })];
            case 2:
                json = _a.sent();
                Cookies.set(BOMBAS_GUID_COOKIE, json.guid, {
                    expires: TEN_YEARS,
                    domain: getCookieDomain()
                });
                delete window.isRequestingUserId;
                return [2 /*return*/, Promise.resolve(json.guid)];
            case 3:
                e_1 = _a.sent();
                delete window.isRequestingUserId;
                throw e_1;
            case 4: return [2 /*return*/];
        }
    });
}); };
/**
 * Returns the users initial GUID (if present) to ensure identifier is consistent for AB testing purposes
 * @see {@link https://docs.developers.optimizely.com/full-stack/docs/handle-user-ids}
 */
export var getStaticBrowserIdentifier = function () {
    var bombasId = Cookies.get(BOMBAS_GUID_COOKIE);
    var browserId = Cookies.get(BROWSER_GUID_COOKIE);
    // Remove Browser GUID if Bombas ID has also been removed
    if (!bombasId) {
        Cookies.remove(BROWSER_GUID_COOKIE);
        return undefined;
    }
    if (!browserId) {
        Cookies.set(BROWSER_GUID_COOKIE, bombasId, {
            expires: TEN_YEARS,
            domain: getCookieDomain()
        });
        browserId = bombasId;
    }
    // TODO: Remove this and update GTM to pull from Cookie value
    dataLayerPush({
        customer: { guid: bombasId },
        browser: { guid: browserId }
    });
    return browserId;
};
